import { checkInvalidPrimaryKey } from 'GenericForms/Helper';
import { successToast, warningToast } from '../Components/Toasts';
import apiGlobal from '../global/api.global';
import { queryKeyes } from '../shared/queryKeys';
import { getAuthData } from 'utils/auth/authUtils';
import {
  EngineTypeConstant,
  EventPrecedence,
  FuelTypes,
} from 'shared/constants';
import { Filtervalues } from 'shared/CommonInterface';

/**generic get function eith no id  */
export const Get = async (url: string, ...primaryKeys: (number | null | undefined)[]) => {
  // Run check only if keys are passed
  if (primaryKeys.length > 0 && !checkInvalidPrimaryKey(...primaryKeys)) {
    return [];
  }

  try {
    const response = await apiGlobal.get(url);
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};


export const loadCompletedReports = async (
  vesselId: number,
  voyageId: number,
  url: string,
) => {
  if (!checkInvalidPrimaryKey(vesselId, voyageId)) {
    return [];
  } else {
    try {
      const response = await apiGlobal.get(url);
      return response.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
};
/**
 * Retruns Next Possible operation of report
 * @param number last_report_event_id
 * @param number current_possible_event_id
 * @returns
 */
export const nextPossibleOperations = async (
  current_possible_event_id: number,
  last_report_event_id: number,
) => {
  try {
    if (current_possible_event_id && last_report_event_id) {
      const response = await apiGlobal.get(
        `/possible_operations_since_last_report/get_next_possible_operations/?current_possible_event_id=${current_possible_event_id}&last_report_event_id=${last_report_event_id}`,
      );
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * Function Returns next possible events
 * @param reporting_event
 * @returns
 */
export const nextPossibleEvents = async (reporting_event: number) => {
  try {
    if (reporting_event) {
      const response = await apiGlobal.get(
        `/event_management/get_next_events_by_event/?event_id=${reporting_event}`,
      );
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * Common Submit Data function to do post
 * @param data
 * @param url
 * @returns
 */
export const commonPost = async (
  data: any,
  url: string,
  message: { success?: string; error?: string } = {},
) => {
  try {
    const response = await apiGlobal.post(url, data);
    if (response.status === 200 || response.status === 201) {
      successToast(message?.success ?? 'Data saved successfully!');
    } else {
      warningToast(message?.error ?? 'Unable to process reauest!');
    }
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Common function to make patch request
 */
export const commonRequest = async (
  url: string,
  data: any,
  method: string,
  message: { success?: string; error?: string } = {},
) => {
  try {
    const response = await apiGlobal.request({
      url,
      method,
      data,
    });

    if (response.status === 200 || response.status === 201) {
      successToast(message?.success ?? 'Data saved successfully!');
    }
    return response.data;
  } catch (error) {
    console.error(error);
  }
};


/**
 * Returns the array with machinary fuel group of vessel
 * @returns
 */
export const loadMachineryFuelGroup = async (VesselID: number) => {
  if (!checkInvalidPrimaryKey(VesselID)) {
    return [];
  } else {
    try {
      const response = await apiGlobal(
        queryKeyes.vessel.MachinaryFuelGroupByVesselId.url(VesselID),
      );
      return response.data?.filter((item: any) => item.display === true);
    } catch (err) {
      console.error(err);
    }
  }
};

/**
 * Returns the array with machinary energy group of vessel
 * @returns
 */
export const loadMachineryEnergyGroup = async (VesselID: number) => {
  if (!checkInvalidPrimaryKey(VesselID)) {
    return [];
  } else {
    try {
      const response = await apiGlobal(
        queryKeyes.vessel.MachinaryEnergyGroupByVesselId.url(VesselID),
      );
      return response.data?.filter((item: any) => item.display === true);
    } catch (err) {
      console.error(err);
    }
  }
};

/**
 * Get Vessel Machines
 * @param VesselID, machineType
 * @returns
 */
export const loadVesselMachineriesByMachineType = async (
  VesselID: number,
  machineType: number,
) => {
  if (!checkInvalidPrimaryKey(VesselID, machineType)) {
    return [];
  } else {
    try {
      const response = await apiGlobal.get(
        queryKeyes.vessel.VesselMachineries.url(VesselID),
      );
      return response.data?.filter(
        (item: any) => item.machinery_precedence_id === machineType,
      );
    } catch (error) {
      console.error(error);
      return [];
    }
  }
};

/**
 * Load CII Adjustment data vessel specific
 *
 * @param number vesselId
 * @returns array
 */
export const loadCiiAssesmentGraphData = async (
  vesselId: number,
  values: Filtervalues,
  selectedYear: number
) => {
  if (!checkInvalidPrimaryKey(vesselId, selectedYear)) {
    return [];
  }
  const { selectedRadio } = values;
  const requestBody: any = {
    vessel_id: vesselId,
  };


  requestBody.year = selectedYear;
  if (selectedRadio === 'startDate') {
    requestBody.start_report_id = values.startReport;
    requestBody.end_report_id = values.endReport;
  } else if (selectedRadio === 'voyages') {
    requestBody.voyages = values.voyages; // Ensure it's an array like [10, 15]
  }
  try {
    const response = await apiGlobal.post(
      queryKeyes.vessel.CIIAssessmentData.url(vesselId, selectedYear),
      requestBody // 🔥 this goes in the body of POST
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};
/**
 * Load engine types from master
 * @param -
 * @returns array
 */
export const loadEngineTypes = async (
  vesselId: number,
  vesselFuelIds?: any[],
  engineType?: string,
) => {
  if (!checkInvalidPrimaryKey(vesselId)) {
    return [];
  } else {
    try {
      const response = await apiGlobal.get(
        queryKeyes.masters.EngineTypeMaster.url(),
      );
      if (vesselFuelIds && engineType) {
        if (
          !vesselFuelIds?.includes(FuelTypes.LNG_BUNKER) &&
          !vesselFuelIds?.includes(FuelTypes.LNG_BUNKER)
        ) {
          response.data = response.data?.filter(
            (res: { [key: string]: string | number | Date | boolean }) =>
              res?.id !== EngineTypeConstant.LNG_OTTO_MED_SPEED && res?.id !== EngineTypeConstant.LNG_DIESEL &&
              res?.id !== EngineTypeConstant.LNG_OTTO_SLW_SPEED,
          );
        } else {
          if (engineType === '2_stroke') {
            response.data = response.data?.filter(
              (res: { [key: string]: string | number | Date | boolean }) =>
                res?.id !== EngineTypeConstant.LNG_OTTO_MED_SPEED,
            );
          } else if (engineType === '4_stroke') {
            response.data = response.data?.filter(
              (res: { [key: string]: string | number | Date | boolean }) =>
                res?.id !== EngineTypeConstant.LNG_OTTO_SLW_SPEED,
            );
          }
        }
        if (!vesselFuelIds?.includes(FuelTypes.H2)) {
          response.data = response.data?.filter(
            (res: { [key: string]: string | number | Date | boolean }) =>
              res?.id !== EngineTypeConstant.FUEL_CELL,
          );
        }
      }
      return response.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
};
/**
 * Load current vessel's fuel data
 * @param vesselId
 * @returns array
 */
export const loadVesselFuel = async (vesselId: number) => {
  if (!checkInvalidPrimaryKey(vesselId)) {
    return [];
  } else {
    try {
      const response = await apiGlobal.get(
        queryKeyes.vessel.vesselFuel.url(vesselId),
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
};

/**
 * Fetches the status of a specific file based on the provided file name.
 * @param {string} fileName - The name of the file to retrieve the status for.
 * @returns {Promise<Object>} - A promise that resolves to the status of the specific file.
 */
export const syncFileStatusByFileName = async (fileName: string) => {
  try {
    const response = await apiGlobal.get(
      queryKeyes.sync.syncFileStatusByFileName.url(fileName),
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

/**
 * Fetches the list of all notifications.
 * @returns {Promise<Array>} - A promise that resolves to an array of notifications.
 */
export const loadCommonNotificationURL = async (url: string) => {
  try {
    if (url) {
      if (url === 'notification/archive/') {
        const response = await apiGlobal.get(url);
        const user = getAuthData('user_id');
        const data = response?.data?.results?.filter(
          (item: any) => item.user === user,
        );
        response.data.results = data;
        return response?.data;
      } else {
        const response = await apiGlobal.get(url);
        return response.data;
      }
    } else {
      return {};
    }
  } catch (error) {
    console.error(error);
    return {};
  }
};

/**
 * load vessel's data & update the passed state object required for simulator
 * @param vesselId,
 * @returns object
 */
export const loadSimulatorVesselDataObject = async (vesselId: number, weatherCondition: string) => {
  if (!checkInvalidPrimaryKey(vesselId)) {
    return [];
  } else {
    try {
      const response = await apiGlobal.get(
        queryKeyes.vessel.SimulatorVesselDataObject.url(vesselId, weatherCondition),
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
};
/**
 * Local vessel reporting CII adjustment by vessel
 * @param vesselId
 * @returns
 */
export const loadCIIAdjustmentEvents = async (vesselId: number) => {
  if (!checkInvalidPrimaryKey(vesselId)) {
    return [];
  } else {
    try {
      const response = await apiGlobal.get(
        queryKeyes.vessel.VesselReportingCIIAdjusment.url(vesselId),
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
};
/**
 * To get all Reporting Events
 * @param -
 * @returns
 */
export const loadReportingEventsMaster = async (initialReporting: boolean = false, otherThanNoon: boolean = false) => {
  try {
    const response = await apiGlobal.get(
      queryKeyes.masters.ReportingEventsMaster.url(),
    );
    return response.data?.filter((item: any) =>
      initialReporting && otherThanNoon ?
        item.event_precedence_id !== EventPrecedence.CII_ADJUSTMENT_EVENT && item.event_precedence_id !== EventPrecedence.NOON :
        initialReporting ?
          item.event_precedence_id !== EventPrecedence.CII_ADJUSTMENT_EVENT : true) as Array<{ [key: string]: string | number }>;
  } catch (error) {
    console.error(error);
    return [];
  }
};

/**
 * To get all Reporting Operations
 * @param -
 * @returns
 */
export const loadReportingOperationsMaster = async () => {
  try {
    const response = await apiGlobal.get(
      queryKeyes.masters.ReportingOperationsMaster.url(),
    );
    return response.data as Array<{ [key: string]: string | number }>;
  } catch (error) {
    console.error(error);
    return [];
  }
};

/**
 * Load current voyage's object
 * @param vesselId
 * @returns object
 */
export const loadOnboardingVoyageObject = async (vesselId: number) => {
  if (!checkInvalidPrimaryKey(vesselId)) {
    return [];
  } else {
    try {
      const response = await apiGlobal.get(
        queryKeyes.vessel.GetOnboardingVoyageByVessel.url(vesselId),
      );
      return response.data[0];
    } catch (error) {
      console.error(error);
      return [];
    }
  }
};

/**
 * Load current fresh water object
 * @param vesselId
 * @returns object
 */
export const loadOnboardingOtherROBObject = async (vesselId: number) => {
  if (!checkInvalidPrimaryKey(vesselId)) {
    return [];
  } else {
    try {
      const response = await apiGlobal.get(
        queryKeyes.vessel.GetOnboardingOtherByVessel.url(vesselId),
      );
      return response.data[0];
    } catch (error) {
      console.error(error);
      return [];
    }
  }
};
/**
 * get user by role
 * @param role
 * @returns list of users with said role
 */
export const Getuserbyrole = async (role: string) => {
  try {
    const response = await apiGlobal.get(
      queryKeyes.vessel.Getuserbyrole.url(role),
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

/**get consumction by vessel and speed */
export const loadSpeedConsumptionObject = async (
  vesselId: number,
  reportId: number,
  orderedSpeed?: number,
) => {
  if (!checkInvalidPrimaryKey(vesselId, reportId)) {
    return [];
  } else {
    try {
      if (orderedSpeed) {
        const response = await apiGlobal.get(
          queryKeyes.vessel.SpeedConsumptionObject.url(vesselId, orderedSpeed),
        );
        return response.data;
      } else {
        const weatherResponse = await apiGlobal.get(
          queryKeyes.vessel.WeatherDataObject.url(vesselId, reportId),
        );
        if (weatherResponse.status === 200) {
          const response = await apiGlobal.get(
            queryKeyes.vessel.SpeedConsumptionObject.url(
              vesselId,
              weatherResponse.data[0].avg_ground_speed,
            ),
          );
          return response.data;
        }
      }
    } catch (error) {
      console.error(error);
      return [];
    }
  }
};

/**
 * load excel to json converted data by import_previous_reporting id
 * @param fileID
 * @returns
 */
export const loadExcelToJson = async (fileID: number) => {
  try {
    const response = await apiGlobal.get(
      `${queryKeyes.vessel.ExcelToJson.url()}${fileID}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

/**
 * load import_previous_reporting data by ID
 * @param ID
 * @returns
 */
export const loadPreviousReportingDataByID = async (ID: number) => {
  try {
    const response = await apiGlobal.get(
      `${queryKeyes.vessel.ImportPreviousReporting.url()}${ID}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

/**
 * fetch Saved operaton by report_id
 * @param reportId
 * @returns object of saved operation
 */
export const fetchSavedOperation = async (reportId: number) => {
  checkInvalidPrimaryKey(reportId);
  try {
    const response = await apiGlobal.get(
      queryKeyes.vessel.OptionalOperationStatus.url(reportId),
    );
    return response.data.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

/**Check edit permission */
export const checkEditPermission = async (vesselId: number, force: boolean) => {
  if (!checkInvalidPrimaryKey(vesselId)) {
    return [];
  }
  try {
    const response = await apiGlobal.get(
      queryKeyes.edit.checkEditPermission.url(vesselId, force),
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};